var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wechat-quick-login"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.login.loading,
      expression: "!login.loading"
    }],
    staticClass: "back-icon",
    on: {
      "click": _vm.onBackLoginMain
    }
  }, [_c('span', {
    staticClass: "iconfont icon-Edit_fanhui_return_linear back-icon-content"
  })]), _c('h1', {
    staticClass: "title"
  }, [_vm._v($t("h0d4bk7", "登录iWork"))]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v($t("mck0epf", "欢迎回来！请继续登录iWork"))]), _c('div', {
    staticClass: "wechat-avatar"
  }, [_c('img', {
    staticClass: "avatar-img",
    attrs: {
      "src": _vm.savedUserImg
    }
  })]), _c('div', {
    staticClass: "avatar-name"
  }, [_vm._v(" " + _vm._s(_vm.savedUserInfo.userName) + " ")]), !_vm.sendMessage ? _c('div', [_c('Button', {
    staticClass: "continue-btn",
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.login.loading
    },
    on: {
      "click": _vm.savedLogin
    }
  }, [_vm._v(` ${$t("ma5i2", "继续")} `), _c('Icon', {
    staticClass: "continue-icon",
    attrs: {
      "type": "md-arrow-forward"
    }
  })], 1)], 1) : _c('div', [_c('Button', {
    staticClass: "continue-btn-cancel",
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.onBackLoginMain
    }
  }, [_vm._v(` ${$t("b1a8to4", "取消登录")} `)]), _c('div', {
    staticClass: "click-login-text"
  }, [_vm._v($t("11udw9c", "请在手机上点击确定以登录"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };